import { Toaster as Sonner } from "sonner";

import { useUiStore } from "@/stores/uiStore";

export function Toaster() {
  const theme = useUiStore((s) => s.theme);
  return (
    <Sonner
      theme={theme === "system" ? "system" : theme}
      position="top-right"
      richColors
      closeButton
    />
  );
}
